var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFirstMedal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9574 38.1165C34.483 38.1165 43.0157 29.5839 43.0157 19.0583C43.0157 8.53268 34.483 0 23.9574 0C13.4318 0 4.89917 8.53268 4.89917 19.0583C4.89917 29.5839 13.4318 38.1165 23.9574 38.1165Z",
    fill: "#FFBB33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51811 30.2079L1.96063 41.5748L9.61418 41.1685L13.0913 48L19.1575 37.4835C14.811 36.3591 11.0787 33.7417 8.51811 30.2079Z",
    fill: "#D83D59"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4346 30.1512C36.8929 33.6945 33.1606 36.3213 28.8236 37.4646L34.9086 48L38.3858 41.1685L46.0393 41.5748L39.4346 30.1512Z",
    fill: "#D83D59"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9575 32.8724C31.5868 32.8724 37.7717 26.6876 37.7717 19.0583C37.7717 11.4289 31.5868 5.24408 23.9575 5.24408C16.3281 5.24408 10.1433 11.4289 10.1433 19.0583C10.1433 26.6876 16.3281 32.8724 23.9575 32.8724Z",
    fill: "#E68A2E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M27.018 24.128C27.738 24.128 28.098 24.434 28.098 25.046C28.098 25.682 27.738 26 27.018 26H20.934C20.202 26 19.836 25.682 19.836 25.046C19.836 24.434 20.202 24.128 20.934 24.128H22.806V15.92L21.078 16.982C20.91 17.078 20.76 17.126 20.628 17.126C20.376 17.126 20.16 17.018 19.98 16.802C19.812 16.586 19.728 16.346 19.728 16.082C19.728 15.734 19.884 15.464 20.196 15.272L22.986 13.544C23.346 13.328 23.688 13.22 24.012 13.22C24.348 13.22 24.618 13.322 24.822 13.526C25.026 13.73 25.128 14.012 25.128 14.372V24.128H27.018Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstMedal);
export default __webpack_public_path__ + "static/media/first_medal.5300862685a226663528679520de06d4.svg";
export { ForwardRef as ReactComponent };